exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-login{\n    border-radius: 0px;\n    height: 60px;\n}\n\n.btn-log{\n    color:red;\n}\n.btn-log:hover{\n    color:rgb(255, 255, 255);\n    transition: .5s;\n}\n.btn-warning {\n    color: #ffffff!important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/login/login.component.css
// module id = ../../../../../src/app/components/login/login.component.css
// module chunks = main